module.exports = __webpack_public_path__ + "img/patent_image12.f5f858b5.png";